import { Injectable, ErrorHandler } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  IApiResponse,
  ITableDto,
  ITimeSlotDto,
  IWorkingDayDto,
} from '../models';

@Injectable()
export class TableService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getWorkingDaysWithTime(id: number): Observable<IWorkingDayDto[]> {
    return this.get(`table/${id}`);
  }

  public getWorkingDays(id: number): Observable<string[]> {
    return this.get(`table/workingDays/${id}`);
  }

  public getWorkingTimeSlots(model: ITimeSlotDto): Observable<string[]> {
    return this.post(`table/workingTime`, model);
  }

  public bookTable(model: ITableDto): Observable<IApiResponse<boolean>> {
    return this.post(`table`, model);
  }
}
